import { Component, Inject, OnInit, Optional } from '@angular/core';
import { DataTask0To99Service, MenuItem } from '@app/core/services/datatask/data-task-0-to-99.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
  selector: 'tt-sr-user-admin',
  templateUrl: './sr-user-admin.component.html',
  styleUrls: ['./sr-user-admin.component.css'],
  standalone: false,
})
export class SrUserAdminComponent implements OnInit {
    public items: MenuItem[] = [];
    public error = '';
    constructor(private menu: DataTask0To99Service, @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) { this.navigator = useNavigatorFor(navigator, this); }
    public async ngOnInit(): Promise<void> { try { this.items = await this.menu.dt53({ webpageName: 'sruseradmin' }); } catch (error) { this.error = error instanceof Error ? error.message : String(error); } }
    public openItem(event: { item: MenuItem; event: MouseEvent }): void {
        if (!event.item.item_state) return;
        const to = ['srusers', 'sruser', 'sruseradmin'].includes(event.item.item_state) ? `${event.item.item_state}-test` : event.item.item_state;
        const target = { to, parms: event.item.item_parms };
        if (event.event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }

}
